import { useParams } from "react-router-dom";
import { useTenant } from "../hooks/useTenant";
import { TenantSettingsEditor } from "../components/editor/TenantSettingsEditor";
import { colors } from "../lib/tokens";

export function TenantBrandingPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const { tenant, loading } = useTenant(slug);
  if (loading || !tenant) return <div style={{ color: colors.stone }}>Carregando...</div>;
  return <TenantSettingsEditor tenantId={tenant.id} section="branding" />;
}
